/*
 *   Copyright (c) 2022 nVipani Technology Solutions Private Limited.
 *   All rights reserved.
 */
import { CurrentPagePipe } from "./../current-page.pipe";
import { PaginationComponent } from "./pagination/pagination.component";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { AgmCoreModule } from "@agm/core";
import { ScanCameraIconComponent } from "./scan-camera-icon/scan-camera-icon.component";
import { QuantityViewComponent } from "./quantity-view/quantity-view.component";
import { ProductHomeRatingComponent } from "./product-home-rating/product-home-rating.component";
import { ProductHomeProfileComponent } from "./product-home-profile/product-home-profile.component";
import { FavoriteComponent } from "./favorite/favorite.component";
import { NavigateBackComponent } from "./navigate-back/navigate-back.component";
import { SimilarImagesComponent } from "./similar-images/similar-images.component";
import { StoreLocationComponent } from "./store-location/store-location.component";
import { MatIconModule } from "@angular/material/icon";
import { FlexLayoutModule } from "@angular/flex-layout";
import { UserProfilePicComponent } from "./user-profile-pic/user-profile-pic.component";
import { SubmitButtonComponent } from "./submit-button/submit-button.component";
import { UserHeaderComponent } from "./user-header/user-header.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { HomeIconComponent } from "./home-icon/home-icon.component";
import { DocViewerComponent } from "./doc-viewer/doc-viewer.component";
import { NgxDocViewerModule } from "ngx-doc-viewer";
import { StarFillComponent } from "./star-fill/star-fill.component";
import { DateComponent } from "./date/date.component";
import { AddressFormComponent } from "./address-form/address-form.component";
import { CartStoreItemComponent } from "./cart-store-item/cart-store-item.component";
import { SelectProductInventoryCountComponent } from "./select-product-inventory-count/select-product-inventory-count.component";
import { SingleCartItemComponent } from "./single-cart-item/single-cart-item.component";
import { MapsComponent } from "./maps/maps.component";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatRadioModule } from "@angular/material/radio";
import { SearchComponent } from "./search/search.component";
import { SingleProductViewComponent } from "./single-product-view/single-product-view.component";
import { DesignBasicComponent } from "./design-basic/design-basic.component";
import { ProductDetailingComponent } from "./product-detailing/product-detailing.component";
import { DialogComponent } from "./dialog/dialog.component";
import { MatDialogModule } from "@angular/material/dialog";
import { BusinessUnitSelectionComponent } from "./business-unit-selection/business-unit-selection.component";
import { FiltersComponent } from "./filters/filters.component";
import { BusinessUnitsListComponent } from "./business-units-list/business-units-list.component";
import { ProfileImageComponent } from "./profile-image/profile-image.component";
import { MatMenuModule } from "@angular/material/menu";
import { SortTimePipe } from "./sort-time.pipe";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { ImageZoomComponent } from "./image-zoom/image-zoom.component";
import { UsphoneformatPipe } from "./usphoneformat.pipe";
import { MatTooltipModule } from "@angular/material/tooltip";
import {
  addCarouselItemComponent,
  ProductSelectionDialog,
} from "./addCarouselItem/addCarouselItem.component";
import { MatTreeModule } from "@angular/material/tree";
import { RouterModule } from "@angular/router";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatSelectModule } from "@angular/material/select";
import { ConfirmDialogComponent } from "./confirm-dialog/confirm-dialog.component";
import { SearchFilterPipe } from "./search-filter/search-filter.pipe";
import { ChartsComponent } from "./charts/charts.component";
import { MapchartComponent } from "./mapchart/mapchart.component";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { ViewmapchartComponent } from "./viewmapchart/viewmapchart.component";
import { PipVideoComponent } from "./pip-video/pip-video.component";
import { ShopifyDetailsFormComponent } from "./shopify-details-form/shopify-details-form.component";
import { OrderLinkFooterComponent } from "../../shared/commoncomponents/order-link-footer/order-link-footer.component";
import { MatDividerModule } from "@angular/material/divider";
import { ReplacePipe } from "./replace.pipe";
import { CartHeaderComponent } from "./cart-header/cart-header.component";
import { MatSidenavModule } from "@angular/material/sidenav";
import { APIKEY } from "src/environments/config";
import { SearchScrollComponent } from "./search-scroll/search-scroll.component";
import { PromolinkHeaderComponent } from "./promolink-header/promolink-header.component";
import { ProductSummaryViewComponent } from "./product-summary-view/product-summary-view.component";
import { SelectContactComponent } from "./select-contact/select-contact.component";
import { SelectProductComponent } from "./select-product/select-product.component";
import { ApplyCouponComponent } from "./apply-coupon/apply-coupon.component";
import { CarouselComponent } from "./carousel/carousel.component";

@NgModule({
  declarations: [
    StoreLocationComponent,
    ScanCameraIconComponent,
    NavigateBackComponent,
    SingleProductViewComponent,
    ConfirmDialogComponent,
    DesignBasicComponent,
    ProductDetailingComponent,
    StarFillComponent,
    ScanCameraIconComponent,
    QuantityViewComponent,
    ProductHomeRatingComponent,
    ProductHomeProfileComponent,
    FavoriteComponent,
    SelectProductInventoryCountComponent,
    DateComponent,
    SimilarImagesComponent,
    UserProfilePicComponent,
    SubmitButtonComponent,
    UserHeaderComponent,
    HomeIconComponent,
    DocViewerComponent,
    AddressFormComponent,
    SingleCartItemComponent,
    CartStoreItemComponent,
    MapsComponent,
    SearchComponent,
    DialogComponent,
    PaginationComponent,
    CurrentPagePipe,
    BusinessUnitSelectionComponent,
    FiltersComponent,
    BusinessUnitsListComponent,
    ProfileImageComponent,
    SortTimePipe,
    ImageZoomComponent,
    UsphoneformatPipe,
    addCarouselItemComponent,
    ProductSelectionDialog,
    SearchFilterPipe,
    ChartsComponent,
    MapchartComponent,
    ViewmapchartComponent,
    PipVideoComponent,
    ShopifyDetailsFormComponent,
    OrderLinkFooterComponent,
    ReplacePipe,
    CartHeaderComponent,
    SearchScrollComponent,
    PromolinkHeaderComponent,
    ProductSummaryViewComponent,
    SelectContactComponent,
    SelectProductComponent,
    ApplyCouponComponent,
    CarouselComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    MatIconModule,
    FlexLayoutModule,
    NgxDocViewerModule,
    AgmCoreModule.forRoot({
      apiKey: APIKEY.googleMapsAPIKEY,
      libraries: ["places"],
    }),
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatRadioModule,
    MatDialogModule,
    MatMenuModule,
    MatProgressBarModule,
    ReactiveFormsModule,
    MatTooltipModule,
    MatTreeModule,
    RouterModule,
    MatToolbarModule,
    MatCheckboxModule,
    MatSelectModule,
    DragDropModule,
    MatDividerModule,
    MatSidenavModule,
  ],

  exports: [
    PipVideoComponent,
    DocViewerComponent,
    StoreLocationComponent,
    SelectProductInventoryCountComponent,
    ScanCameraIconComponent,
    NavigateBackComponent,
    DateComponent,
    ScanCameraIconComponent,
    SingleProductViewComponent,
    DesignBasicComponent,
    ProductDetailingComponent,
    QuantityViewComponent,
    ProductHomeRatingComponent,
    ProductHomeProfileComponent,
    FavoriteComponent,
    SimilarImagesComponent,
    StarFillComponent,
    UserProfilePicComponent,
    SubmitButtonComponent,
    UserHeaderComponent,
    HomeIconComponent,
    CartStoreItemComponent,
    SearchComponent,
    PaginationComponent,
    CurrentPagePipe,
    BusinessUnitSelectionComponent,
    BusinessUnitsListComponent,
    ProfileImageComponent,
    MatMenuModule,
    SortTimePipe,
    MapsComponent,
    ImageZoomComponent,
    UsphoneformatPipe,
    ReplacePipe,
    addCarouselItemComponent,
    SearchFilterPipe,
    ChartsComponent,
    MapchartComponent,
    ShopifyDetailsFormComponent,
    OrderLinkFooterComponent,
    CartHeaderComponent,
    PromolinkHeaderComponent,
    ProductSummaryViewComponent,
    CarouselComponent,
  ],
})
export class CommoncomponentsModule {}
